<kendo-splitter>
  <kendo-splitter-pane [scrollable]="false" (sizeChange)="splitter_sizeChange($event)">
    <app-daily-checks (mySelected)="list_onSelected($event)"></app-daily-checks>
  </kendo-splitter-pane>

  <kendo-splitter-pane size="40%" [collapsible]="true" [scrollable]="false" (sizeChange)="splitter_sizeChange($event)">
    <app-daily-checks-details [modelId]="selectedId$ | async"></app-daily-checks-details>
  </kendo-splitter-pane>
</kendo-splitter>
